import PropTypes from 'prop-types';
import React from 'react';
import {Typography} from '@mui/material';

// component for labeling both inputs and other values/components
// when used as a label for inputs, pass isInputLabel and htmlFor

export const Label = ({
  children,
  isInputLabel = false,
  htmlFor,
  style,
  ...props
}) => (
  <Typography
    color="text.secondary"
    component={isInputLabel ? 'label' : 'p'}
    sx={{
      display: 'block',
      marginBottom: '5px',
      marginTop: '10px',
      ...style,
    }}
    htmlFor={htmlFor}
    variant="subtitle2"
    {...props}
  >
    {children}
  </Typography>
);

Label.propTypes = {
  children: PropTypes.node,
  isInputLabel: PropTypes.bool,
  htmlFor: PropTypes.string,
  style: PropTypes.object,
};

export const LabelValue = ({children, style}) => (
  <Typography
    sx={{
      marginTop: 0.5,
      ...style,
    }}
  >
    {children}
  </Typography>
);

LabelValue.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
};
